import portfolioData from "../data/portfolio.json";
import { motion } from "framer-motion";
import { Typewriter } from "react-simple-typewriter";

const IntroductionList = () => {

  const { profile } = portfolioData;

  return (
    <section id="home" className="flex flex-col items-center justify-center min-h-[80vh] text-center w-full">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="w-full max-w-4xl px-4 flex flex-col items-center justify-center space-y-8"
      >
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-semibold tracking-tight text-stone-800 dark:text-stone-100">
          Hi, I am {profile.name}
        </h1>
        <div className="text-2xl md:text-3xl text-stone-600 dark:text-stone-400 font-light max-w-2xl leading-relaxed h-[4rem]">
          <Typewriter
            words={[profile.headline, "Building smooth end-to-end user journeys", "Bridging frontend & backend"]}
            loop={true}
            cursor
            cursorStyle='|'
            typeSpeed={50}
            deleteSpeed={30}
            delaySpeed={2000}
          />
        </div>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6, duration: 1 }}
          className="text-lg md:text-xl text-stone-400 dark:text-stone-500 font-light max-w-3xl leading-relaxed mt-4"
        >
          {profile.location}
        </motion.p>
      </motion.div>
    </section>
  );
};

export default IntroductionList;